import React, {useState} from "react";

export const DROPDOWN_TYPE_CONDITION_OPERATOR = "condition_operator"
export const DROPDOWN_TYPE_CONDITION_BASE = "condition_base"
export const DROPDOWN_TYPE_METRIC = "condition_metric"
export const DROPDOWN_TYPE_REWARD_BASE = "reward_base"
export const DROPDOWN_TYPE_REWARD_OPERATOR = "reward_operator"

export const conditionBaseValues = ["Transaction value", "Total last month", "Total last week", "Total today"]
export const operatorValues = ["greater than", "less than", "equals to"]
export const metricValues = ["m²", "€", "$"]
export const mathematicalOperationValues = ["+", "-", "*", "/"]
export const rewardBaseValues = ["Transaction value", "Total last month", "Total last week", "Total today"]

export const Dropdown = (props) => {
    const [open, setOpen] = useState(false);

    const getInitialSelectionState = () => {
        let selectedDropdownValue = ""

        if (props.initialValue) {
            selectedDropdownValue = props.initialValue;
        } else if (props.dropdownType === DROPDOWN_TYPE_CONDITION_BASE) {
            selectedDropdownValue = conditionBaseValues[0];
        } else if (props.dropdownType === DROPDOWN_TYPE_CONDITION_OPERATOR) {
            selectedDropdownValue = operatorValues[0];
        } else if (props.dropdownType === DROPDOWN_TYPE_METRIC) {
            selectedDropdownValue =  metricValues[0];
        } else if (props.dropdownType === DROPDOWN_TYPE_REWARD_BASE) {
            selectedDropdownValue =  rewardBaseValues[0];
        } else if (props.dropdownType === DROPDOWN_TYPE_REWARD_OPERATOR) {
            selectedDropdownValue = mathematicalOperationValues[0];
        }

        return selectedDropdownValue;
    }

    const [selected, setSelected] = useState(getInitialSelectionState());

    const valuesForType = () => {
        if (props.dropdownType === DROPDOWN_TYPE_CONDITION_BASE) return conditionBaseValues;
        if (props.dropdownType === DROPDOWN_TYPE_CONDITION_OPERATOR) return operatorValues;
        if (props.dropdownType === DROPDOWN_TYPE_METRIC) return metricValues;
        if (props.dropdownType === DROPDOWN_TYPE_REWARD_BASE) return rewardBaseValues;
        if (props.dropdownType === DROPDOWN_TYPE_REWARD_OPERATOR) return mathematicalOperationValues;
        return [];
    }

    const renderValues = () => {
        return (
            <>
                {valuesForType().map((value, index) => (
                    <li key={index}>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                setSelected(value)
                                props.setSelected(props.id, props.dropdownType, value)
                                setOpen(false)
                            }}
                            href="#"
                            className="block px-4 py-2 text-body-md text-ink hover:bg-surface-soft transition-colors cursor-pointer"
                        >
                            {value}
                        </a>
                    </li>
                ))}
            </>
        );
    }

    return (
        <div className="relative">
            <button
                onClick={()=> setOpen(!open)}
                className={`${props.className || ""} max-w-fit whitespace-nowrap text-body-md font-medium h-11 px-4 inline-flex items-center bg-canvas text-ink border border-hairline rounded-sm hover:bg-surface-soft transition-colors`}
                type="button"
            >
                {selected}
                <svg className="w-2.5 h-2.5 ml-3 text-muted" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/>
                </svg>
            </button>

            <div className={`${!open ? "hidden" : ""} absolute z-20 mt-2 min-w-full w-fit bg-canvas border border-hairline rounded-md shadow-card`}>
                <ul className="py-1">
                    {renderValues()}
                </ul>
            </div>
        </div>
    )
}
